/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_Send_MessageInputs */

const en_friends_send_message = /** @type {(inputs: Friends_Send_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message (optional)`)
};

const de_friends_send_message = /** @type {(inputs: Friends_Send_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht (optional)`)
};

/**
* | output |
* | --- |
* | "Message (optional)" |
*
* @param {Friends_Send_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_send_message = /** @type {((inputs?: Friends_Send_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_Send_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_send_message(inputs)
	return en_friends_send_message(inputs)
});